import UnidadeService from '@/src/services/unidade';

const unidadeMixin = {
    data(){
        return {
            unidadesFields: [
                {
                  key: 'unidade',
                  label: 'Unidade',
                  class: 'size-col-20',
                  field: 'unidade'
                },
                {
                  key: 'cidade',
                  label: 'Cidade',
                  class: 'size-col-30',
                  field: 'cidade'
                },
                {
                  key: 'local',
                  label: 'Endereço',
                  class: 'size-col-50',
                  field: 'local'
                },
                {
                  key: 'total',
                  label: 'Total',
                  class: 'size-col-20',
                  field: 'total'
                },
                { key: 'actions', label: '', class: 'size-col-10' },
              ],
        }
    },
    methods: {
        async registerUnidade(unidade) {
            await UnidadeService.create(unidade)
        },
        loadUnidades() {
            let unidades = [];

            return UnidadeService
                    .list()
                    .then(response => {
                        response.data.map(unidade => unidades.push(unidade._doc))
                        return unidades
                    })
                    .catch( error => error )
        },
        async editUnidade(id, unidade) {
            await UnidadeService.update(id, unidade)
        },
        async deleteUnidade(id) {
            await UnidadeService.remove(id)
        }
    }
}

export default unidadeMixin;